module.exports = __webpack_public_path__ + "static/img/step3-2.b2271a3.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/howto/step3-2.gif
// module id = 39cT
// module chunks = 1